import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export const Index = {
    auth: authRoles.hauling,
    routes: [{ path: '/list-schedule-routes', component: FuseLoadable({ loader: () => import('./RoutesApp') }) }],
};

export default [Index];
